module.exports = __webpack_public_path__ + "img/ChildChallenge.97f8d4c7.svg";